import React from "react";
import {NomenclatureFormCreate} from "../../components/nomenclature/form/NomenclatureFormCreate";

export function CreateNomenclatureForm () {
    return (
        <NomenclatureFormCreate/>
    )
}